import React from "react";
import EmprestimoListPageContainer from "./EmprestimoListPageContainer";

export class EmprestimoListPage extends React.Component {
  render() {
    return <EmprestimoListPageContainer {...this.props} />;
  }
}
